export default "__VITE_ASSET__32437021__"